import React from "react";

import { Card, Flex, Icon, Typography } from "components";

export type SelectableChoiceCardIconColour =
  | "beige"
  | "blue-light"
  | "blue"
  | "green"
  | "grey"
  | "yellow-light"
  | "yellow"
  | "light-green-300"
  | "pink-light"
  | "pink";

export interface SelectableChoiceCardProps {
  title: string;
  description: string;
  icon?: {
    iconName: string;
    colour?: SelectableChoiceCardIconColour;
  };
  bulletPoints?: React.ReactNode[];
  tag?: string;
  selected?: boolean;
  onSelect?: () => void;
  className?: string;
  dataTestId?: string;
}

export const SelectableChoiceCard: React.FC<SelectableChoiceCardProps> = ({
  title,
  description,
  icon,
  bulletPoints,
  tag,
  selected = false,
  onSelect,
  className,
  dataTestId,
}) => (
  <Card className={`selectable-choice-card ${selected ? "selected" : ""} ${className ?? ""}`} onClick={onSelect} data-testid={dataTestId}>
    <Flex justify={icon ? "space-between" : "flex-end"} align="start" className="selectable-choice-card-header">
      {icon && (
        <Flex align="center" justify="center" className={`selectable-choice-card-icon ${icon.colour ?? "grey"}`}>
          <Icon iconName={icon.iconName} />
        </Flex>
      )}
      <Flex gap={12} align="center" className="selectable-choice-card-controls">
        {tag && (
          <Typography variant="paragraph-xs" bold className="selectable-choice-card-tag">
            {tag}
          </Typography>
        )}
        {onSelect && <span className={`selectable-choice-card-radio ${selected ? "selected" : ""}`} />}
      </Flex>
    </Flex>
    <Flex vertical gap={16}>
      <Typography variant="h3">{title}</Typography>
      <Typography variant="paragraph-m" color="grey-600" className="selectable-choice-card-description">
        {description}
      </Typography>
    </Flex>
    {bulletPoints && bulletPoints.length > 0 && (
      <Flex vertical>
        {bulletPoints.map((bulletPoint, index) => (
          <Flex key={index} align="center" gap={8}>
            <Icon iconName="tabler/circle-check" size="xs" className="selectable-choice-card-benefit-icon" />
            <Typography variant="paragraph-s">{bulletPoint}</Typography>
          </Flex>
        ))}
      </Flex>
    )}
  </Card>
);

export default SelectableChoiceCard;
